// extracted by mini-css-extract-plugin
export var button = "regerativeProductCards-module--button--2e338";
export var cafeFormIntro = "regerativeProductCards-module--cafe-form-intro--3a309";
export var card = "regerativeProductCards-module--card--83ef6";
export var cardImage = "regerativeProductCards-module--card-image--48bbd";
export var detail = "regerativeProductCards-module--detail--5aa94";
export var highlight = "regerativeProductCards-module--highlight--24f55";
export var redButton = "regerativeProductCards-module--red-button--51c32";
export var redTransparentButton = "regerativeProductCards-module--red-transparent-button--0da25";
export var subtitle = "regerativeProductCards-module--subtitle--a8743";
export var title = "regerativeProductCards-module--title--3245e";
export var transparentButton = "regerativeProductCards-module--transparent-button--d12bb";
export var wrapper = "regerativeProductCards-module--wrapper--67bed";